import { Button, Progress } from 'antd';
import { FormattedMessage } from 'react-intl';
import { LeftOutlined } from '@ant-design/icons';

import { Props, StepProps } from './Stepper.model';

import styles from './Stepper.module.scss';

const Stepper = (props: Props) => {
	const {
		backLabel,
		children,
		className,
		nextLabel,
		paddedFooter = false,
		progressColor = '#F36B28',
		showSteps = true,
		step,
		title,
		onFinish,
		onStepBack,
		onStepSubmit
	} = props;
	const stepContent = children[step];
	const { hiddenNavigation } = stepContent.props;
	const nrOfSteps = children.length;

	const getStepperPercent = (step: number) => {
		return (step * 100) / nrOfSteps;
	}

	return (
		<div className={`${styles.wrapper} ${className ? className : ''}`}>
			{title && <h3>{title}</h3>}
			{ stepContent }

			<div className={`${styles.footer} ${paddedFooter ? styles.paddedFooter : ''}`}>

				<div className={styles.progressBar}>
					{showSteps && <span>{step + 1} / {nrOfSteps}</span>}
					<Progress
						percent={getStepperPercent(step + 1)}
						showInfo={false}
						size="small"
						strokeColor={progressColor}
					/>
				</div>

				{ !hiddenNavigation &&
				<div className={styles.navigation}>
				{ step > 0 &&
					<Button
						icon={<LeftOutlined style={{ fontSize: 9, marginRight: 4}}/>}
						size="large"
						style={{ color: '#797568'}}
						type="text"
						onClick={onStepBack}
					>	
						{backLabel || <FormattedMessage id="buttons.back" />}
					</Button>
					}

					{ step < nrOfSteps - 1 && <Button
						size="large"
						type="primary"
						onClick={onStepSubmit}
					>	
						{nextLabel || <FormattedMessage id="buttons.next" />}
					</Button>
					}

					{ step === nrOfSteps - 1 && <Button
						size="large"
						type="primary"
						onClick={onFinish}
					>	
						{nextLabel || <FormattedMessage id="buttons.next" />}
					</Button>
					}
				</div>
				}
			</div>

		</div>

	);

}

export const Step = (props: StepProps) => {
	const { children, className, subtitle, title } = props;

	return (
		<div className={`${styles.content} ${className}`}>
			{subtitle && <h3>{subtitle}</h3>}
			{title && <h1>{title}</h1>}
			{children}
		</div>
	)
}

export default Stepper;
